import * as yup from "yup";

export const schemaModalInputs = yup
    .object({
        nameCompany: yup.string().required("Este campo é obrigatório"),
        projectName: yup
            .string()
            .required("Este campo é obrigatório")
            .min(3, "Mínimo de 3 caracteres")
            .max(64, "Máximo de 64 caracteres"),
        email: yup
            .string()
            .email("Email não é válido")
            .required("Este campo é obrigatório"),
        phone: yup.string().required("Este campo é obrigatório"),
        id_cluster_mongo: yup.number(),
        id_cluster_mysql: yup.number(),
        cloud: yup.string().required("Este campo é obrigatório"),
        holder: yup
            .object({
                label: yup.string().required("Label é obrigatório"),
                value: yup.number().required("Value é obrigatório"),
            })
            .required("Este campo é obrigatório"),
        customerDatabase: yup.array().of(
            yup.object({
                backup_enabled: yup.boolean().default(false),
                customer_database_type: yup.string().default(""),
                database_name: yup.string().default(""),
                id: yup.string().default(""),
                ip: yup.string().default(""),
                password: yup.string().default(""),
                port: yup.string().default(""),
                user: yup.string().default(""),
            })
        ),
    })
    .required();
